import type { GuideModule } from '../../../api/useGenerateGuideStructure';
import type { ModuleReportData } from '../../../providers/DeepSearchCompletion';
import { Stack, SubHeading } from '@workramp/ui';
import Markdown from 'react-markdown';
import { DocumentLayout } from './DocumentLayout';
import { MarkdownContainer, ReferencesList } from './ModuleReportMessage.styles';

interface ModuleReportMessageProps {
  module: GuideModule;
  report: ModuleReportData;
}

export function ModuleReportMessage({ module, report }: ModuleReportMessageProps) {
  return (
    <DocumentLayout
      title={module.moduleTitle}
      description={module.objective}
      ctaLabelShow="Show Report"
      ctaLabelHide="Hide Report"
    >
      <Stack size={4}>
        <MarkdownContainer>
          <Markdown>{report.content}</Markdown>
        </MarkdownContainer>

        {report.references && report.references.length > 0 && (
          <ReferencesList>
            <SubHeading level="sm">References</SubHeading>
            <ul>
              {report.references.map((reference) => (
                <li key={`ref-${reference.substring(0, 20)}`}>{reference}</li>
              ))}
            </ul>
          </ReferencesList>
        )}
      </Stack>
    </DocumentLayout>
  );
}
